import React from 'react';

function Home() {
  return (
    <div className="min-h-screen bg-base-200 text-base-content relative pt-0 mt-0">
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 mt-6 w-full max-w-xl px-4 text-center">
      <h1 className="text-4xl font-bold mb-6">Welcome to WFC</h1>
        <p className="text-lg font-medium mb-6">
          A competitive environment for all aspiring Warface players.<br />
          24/7 support, monthly prizes and more!<br />
          Follow our social medias to stay updated!
        </p>
      </div>
    </div>
  );
}

export default Home;